import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito comprar productos caros?',
  a: 'No, el sistema usa lo que ya tienes.'
}, {
  q: '¿Tengo que cocinar todos los días?',
  a: 'No, el sistema te enseña a usar la "falsa cocina" para días críticos.'
}, {
  q: '¿Cuánto tiempo al día requiere?',
  a: 'Máximo 15 a 20 minutos integrados en lo que ya haces.'
}, {
  q: '¿Qué pasa si mi casa es un desastre total hoy?',
  a: 'El Capítulo 1 te da el punto de entrada exacto para frenar la hemorragia de desorden.'
}, {
  q: '¿Es apto para familias con niños pequeños?',
  a: 'Es vital para ellas, porque reduce el caos visual que genera el estrés parental.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-16">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-17">
        <FadeIn data-id="element-18">
          <h2 className="text-4xl md:text-5xl text-center text-charcoal mb-16" data-id="element-19">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-20">
            {faqs.map((faq, index) => <div key={index} className="border border-warmgray/20 rounded-xl overflow-hidden bg-linen/50 transition-colors hover:bg-linen" data-id="element-21">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-22">
                  <span className="font-medium text-charcoal pr-8" data-id="element-23">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-terracotta shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-24" />
                </button>

                <AnimatePresence data-id="element-25">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-26">
                      <div className="px-6 pb-5 text-warmgray border-t border-warmgray/10 pt-4" data-id="element-27">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}